import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { DirectionType, HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';


const stepsList = [
  { text: "1", active: false, completed: false, tooltip: '', listHelp: ['789'] },
  { text: "2", active: true, completed: false, tooltip: ' ', listHelp: ['789'] }
];

const tableStructure = [
  { id: 'tipoCompensacionNombre', title: 'Tipo de compensación' },
  { id: 'tipoRentaNombre', title: 'Tipo de renta' },
  { id: 'valItem', title: 'Valor' }
];

class Form1 {
  id: number;
  tipoCompensacion: string;
  tipoCompensacionNombre: string;
  tipoRenta: string;
  tipoRentaNombre: string;
  valItem: string;
}
@Component({
  selector: 'app-compensacion-modal',
  templateUrl: './compensacion-modal.component.html',
  styleUrls: ['./compensacion-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class CompensacionModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listTipoCompensacion: DValorDominio[] = [];
  public listTipoRenta: DValorDominio[] = [];
  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  mensajeTabla = "¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<CompensacionModalComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);    
  }

  ngOnInit() {
    //Filtro de dominios 2,3,4    
    this.listTipoRenta = this.listTipoRenta.filter(item => Number(item.valor) >= 2 && Number(item.valor) <= 4);
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();    
  }

  protected controlStep(direction: DirectionType): void {}


  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.tipoCompensacion = "";
    this.modelForm.tipoCompensacionNombre = "";
    this.modelForm.tipoRenta = "0";
    this.modelForm.tipoRentaNombre = "";
    this.modelForm.valItem = "0";
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_789 == undefined) {
      this.model.doc.cuerpo.cc_id_789 = [];
      this.model.doc.cuerpo.cc_id_790 = [];
      this.model.doc.cuerpo.cc_id_791 = [];
    }
  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_789.length; i++) {
      this.modelForm.id = i;
      this.modelForm.tipoCompensacion = this.model.doc.cuerpo.cc_id_789[i].v;
      this.modelForm.tipoCompensacionNombre = this.listTipoCompensacion.find(item => item.valor == this.model.doc.cuerpo.cc_id_789[i].v).nombre;
      this.modelForm.tipoRenta = this.model.doc.cuerpo.cc_id_790[i].v;
      this.modelForm.tipoRentaNombre = this.listTipoRenta.find(item => item.valor == this.model.doc.cuerpo.cc_id_790[i].v).nombre;
      this.modelForm.valItem = this.model.doc.cuerpo.cc_id_791[i].v;
      this.dataSourceBody.push(this.modelForm);  
      this.inicializeForm();    
    }
    this.operacionCs792();
  }

  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_789[this.modelForm.id].v = this.modelForm.tipoCompensacion;
    this.model.doc.cuerpo.cc_id_790[this.modelForm.id].v = this.modelForm.tipoRenta;
    this.model.doc.cuerpo.cc_id_791[this.modelForm.id].v = this.modelForm.valItem.toString();
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_789.push({ it: i, v: this.modelForm.tipoCompensacion });
    this.model.doc.cuerpo.cc_id_790.push({ it: i, v: this.modelForm.tipoRenta });
    this.model.doc.cuerpo.cc_id_791.push({ it: i, v: this.modelForm.valItem });    
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_789.splice(index, 1);
    this.model.doc.cuerpo.cc_id_790.splice(index, 1);
    this.model.doc.cuerpo.cc_id_791.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_789.length; i++) {
      this.model.doc.cuerpo.cc_id_789[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_790[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_791[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    return !this.modelForm.tipoCompensacion || !this.modelForm.tipoRenta || !this.modelForm.valItem;
  }

  public redondearFormData() {
    this.modelForm.valItem = this.dutilidades.redondearValorMoneda(this.modelForm.valItem.toString(), true);    
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        this.modelForm.tipoCompensacionNombre = this.listTipoCompensacion[Number(this.modelForm.tipoCompensacion)-1].nombre;
        this.modelForm.tipoRentaNombre = this.listTipoRenta[Number(this.modelForm.tipoRenta)-1].nombre;
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        const existElement = this.dataSourceBody.find(item => 
          item.tipoCompensacion == this.modelForm.tipoCompensacion &&
          item.tipoRenta == this.modelForm.tipoRenta          
        );

        if (existElement) {
          this.dNotificacionServicio.mostrarDialogoInformacion("Ya existe un registro con los mismos conceptos, por favor revise e intente nuevamente");
          return;
        }        

        this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.tipoCompensacionNombre = this.listTipoCompensacion.find(item => item.valor == this.modelForm.tipoCompensacion).nombre; //[Number(this.modelForm.tipoCompensacion)-1].nombre;
        this.modelForm.tipoRentaNombre = this.listTipoRenta.find(item => item.valor == this.modelForm.tipoRenta).nombre; //[Number(this.modelForm.tipoRenta)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      
      //Recalcular y reinicializar
      this.operacionCs792();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') {
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_AGREGAR;
    }
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs792();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];          
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }

  operacionCs792() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valItem, suma);
    }
    this.model.doc.cuerpo.cs_id_792 = suma;
  }

  closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs792();
    this.dialogRef.close("");
  }

  guardar() {
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_789 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
        this.modelForm = this.dataSourceBody[i];
        this.addToModeloDesdeForm(); 
    }

    this.saveModel.emit(true);
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/compensacion-modal/compensacion-modal.component.ts